    (() => {
      const form = document.querySelector('[data-site-search]');
      const input = document.querySelector('[data-site-search-input]');
      const results = document.querySelector('[data-site-search-results]');
      const mode = document.querySelector('[data-site-search-mode]');

      if (!form || !input || !results) {
        return;
      }

      const searchUrl = form.getAttribute('action') || '/search';
      // Shopify predictive search renders the existing theme section (legacy spelling).
      // Use /search/suggest, not the ordinary /search results route.
      const liveSearchSectionId = 'nubs-predicitive-search';

      let requestController = null;
      let debounceTimer = null;
      let activeIndex = -1;
      let currentInput = '';
      const storeResults = new Map();

      document.addEventListener('nubs:session-cleared', () => storeResults.clear());
      document.addEventListener('nubs:cart-changed', () => storeResults.clear());

      const closeResults = () => {
        clearTimeout(debounceTimer);
        requestController?.abort();
        window.NubsCatalogImages?.cancelSpeculation?.();
        form.classList.remove('is-open');
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        activeIndex = -1;
      };

      const openResults = () => {
        form.classList.add('is-open');
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const getResultLinks = () => {
        return Array.from(
          results.querySelectorAll('.site-search-result')
        );
      };

      const setActiveResult = (index) => {
        const links = getResultLinks();

        if (!links.length) {
          activeIndex = -1;
          return;
        }

        links.forEach((link) => {
          link.classList.remove('is-active');
          link.removeAttribute('aria-selected');
        });

        if (index < 0) {
          activeIndex = -1;
          return;
        }

        if (index >= links.length) {
          index = 0;
        }

        activeIndex = index;
        links[activeIndex].classList.add('is-active');
        links[activeIndex].setAttribute('aria-selected', 'true');
        links[activeIndex].scrollIntoView({ block: 'nearest' });
      };

      const escapeHtml = (value) => String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

      const sizedImageUrl = (value, width = 200) => {
        const input = String(value || '');
        if (!input) return '';
        try {
          const url = new URL(input, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch (_) {
          return input;
        }
      };

      const formatFallbackPrice = (value) => {
        const number = Number(value);
        if (!Number.isFinite(number)) {
          return '';
        }

        return new Intl.NumberFormat('en-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(number);
      };


      const databaseBridge = String(document.querySelector('[data-nubs-catalog-client]')?.dataset.bridgeUrl || 'https://members.nubsmedia.ca').replace(/\/$/, '');

      const renderDatabaseResults = async (userQuery) => {
        const q = String(userQuery || '').trim();
        if (q.length < 2) return;
        if (requestController) requestController.abort();
        const controller = new AbortController();
        requestController = controller;
        results.setAttribute('aria-busy', 'true');

        const url = new URL(`${databaseBridge}/catalog/releases`);
        url.searchParams.set('q', q);
        url.searchParams.set('page', '1');
        url.searchParams.set('pageSize', '5');
        url.searchParams.set('sort', 'best-match');
        url.searchParams.set('facets', '0');
        const visibilityToken = window.NubsCatalogClient?.token?.();
        if (visibilityToken) url.searchParams.set('visibilityToken',visibilityToken);

        try {
          const result = window.NubsCatalogClient
            ? await window.NubsCatalogClient.request(url, {signal:controller.signal})
            : await fetch(url, {signal:controller.signal,credentials:'omit',headers:{Accept:'application/json'}}).then(async response => ({ok:response.ok,status:response.status,payload:await response.json().catch(()=>null)}));
          const payload = result.payload;
          if (!result.ok || !payload?.ok) throw new Error(payload?.error || `Database search returned ${result.status}`);
          if (controller.signal.aborted || userQuery !== currentInput || mode?.value !== 'database') return;
          const matches = Array.isArray(payload.items) ? payload.items : [];

          if (!matches.length) {
            results.innerHTML = `
              <div class="site-search__heading">Database</div>
              <div class="site-search__empty">No matching database titles.</div>
              <a class="site-search__view-all" href="/pages/my-collection?q=${encodeURIComponent(userQuery)}">Search database for “${escapeHtml(userQuery)}”</a>`;
            openResults();
            return;
          }

          const cards = matches.map((item, index) => {
            const audioValues = Array.isArray(item.audioLanguages) ? item.audioLanguages : [];
            const hasEnglish = audioValues.some((value) => /^english$/i.test(value));
            const hasJapanese = audioValues.some((value) => /^japanese$/i.test(value));
            const audio = hasEnglish && hasJapanese ? 'Dub | Sub' : hasEnglish ? 'Dub' : hasJapanese ? 'Sub' : audioValues.join(', ');
            const meta = [item.format, item.publisher, audio].filter(Boolean).map(escapeHtml).join(' · ');
            const originalImage = item.cover?.url || '';
            const image = sizedImageUrl(originalImage, 320);
            const priority = index === 0 ? ' fetchpriority="high"' : '';
            return `
              <a class="site-search-result" href="${escapeHtml(item.url)}" role="option" aria-selected="false">
                <span class="site-search-result__image">
                  ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.displayTitle || item.title)}" loading="eager" decoding="async"${priority} data-nubs-image-reveal data-nubs-image-profile="search" data-nubs-cover-url="${escapeHtml(originalImage)}">` : '<span class="site-search-result__image-placeholder">COVER</span>'}
                </span>
                <span class="site-search-result__content">
                  <span class="site-search-result__title">${escapeHtml(item.displayTitle || item.title)}</span>
                  ${meta ? `<span class="site-search-result__meta">${meta}</span>` : ''}
                </span>
              </a>`;
          }).join('');

          results.innerHTML = `
            <div class="site-search__heading">Matching database titles</div>
            <div class="site-search__product-list">${cards}</div>
            <a class="site-search__view-all" href="/pages/my-collection?q=${encodeURIComponent(userQuery)}">View all database results for “${escapeHtml(userQuery)}”</a>`;
          window.NubsCatalogImages?.observe?.(results);
          window.NubsCatalogImages?.speculate?.(q, {visibleItems: matches, profile: 'search'});
          activeIndex = -1;
          openResults();
        } catch (error) {
          if (controller.signal.aborted
            || error?.name === 'AbortError'
            || (error instanceof DOMException && /abort/i.test(error.message || ''))) {
            return;
          }
          throw error;
        } finally {
          if (userQuery === currentInput) results.setAttribute('aria-busy', 'false');
        }
      };

      const renderFuzzyLiveResults = async (userQuery, signal) => {
        if (!window.NubsFuzzySearch) {
          return false;
        }

        const matches = await window.NubsFuzzySearch.search(userQuery, { limit: 5, signal });
        if (signal?.aborted || mode?.value === 'database' || userQuery !== currentInput || matches.length === 0) {
          return false;
        }

        const currency = form.dataset.storeCurrency || 'CAD';
        const cards = matches.map((product, index) => {
          const variant = window.NubsFuzzySearch.firstVariant(product);
          const variantQuery = /^\d+$/.test(String(variant?.id || '')) ? `?variant=${variant.id}` : '';
          const missingVariant = window.NubsConditions?.missing(variant);
          // Never show the slipcovered primary photo for a featured missing-slipcover copy.
          const originalImage = missingVariant ? (variant?.image || '') : (Array.isArray(product.images) ? product.images[0]?.src || product.images[0] : '');
          const image = sizedImageUrl(originalImage, 320);
          const price = variant?.price ?? '';
          const compare = variant?.compare_at_price ?? '';
          const hasDiscount = Number(compare) > Number(price);
          const savings = hasDiscount ? Number(compare) - Number(price) : 0;
          const bundle = window.NubsFuzzySearch.isBundle(product);
          const meta = [product.product_type, product.vendor].filter(Boolean).map(escapeHtml).join(' · ');

          return `
            <a class="site-search-result" href="/products/${encodeURIComponent(product.handle)}${variantQuery}" role="option" aria-selected="false">
              <span class="site-search-result__image">
                ${image
                  ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.display_title || product.title)}" loading="eager" decoding="async"${index === 0 ? ' fetchpriority="high"' : ''} data-nubs-image-reveal data-nubs-image-profile="search" data-nubs-cover-url="${escapeHtml(originalImage)}">`
                  : '<span class="site-search-result__image-placeholder">COVER</span>'}
              </span>
              <span class="site-search-result__content">
                <span class="site-search-result__title">${escapeHtml(product.display_title || product.title)}</span>
                ${meta ? `<span class="site-search-result__meta">${meta}</span>` : ''}
                ${bundle ? '<span class="site-search-result__bundle-callout">Buy bundle and save!</span>' : ''}
                ${window.NubsConditions?.missing(variant) ? '<span class="nubs-product-card__missing">Missing slipcover</span>' : ''}
                ${price !== '' ? `<span class="site-search-result__price">${hasDiscount ? `<span class="site-search-result__compare-price">${formatFallbackPrice(compare)}</span>` : ''}<span>${formatFallbackPrice(price)}</span> <span class="site-search-result__currency">${escapeHtml(currency)}</span></span>` : ''}
                ${hasDiscount ? `<span class="site-search-result__savings">Save ${formatFallbackPrice(savings)} ${escapeHtml(currency)}</span>` : ''}
              </span>
            </a>`;
        }).join('');

        results.innerHTML = `
          <div class="site-search__heading">Closest matches</div>
          <div class="site-search__product-list">${cards}</div>
          <a class="site-search__view-all" href="${searchUrl}?q=${encodeURIComponent(userQuery)}&type=product">Search for “${escapeHtml(userQuery)}”</a>`;
        window.NubsCatalogImages?.observe?.(results);

        return true;
      };

      /*
       * Give Shopify the shopper's exact query. This preserves Shopify's normal
       * typo tolerance, semantic behavior, and Search & Discovery synonyms.
       * Our local fuzzy catalog is used only when Shopify finds no live matches.
       */
      // Shopify is authoritative for published products, current prices and URLs.
      // Use the existing Liquid renderer rather than constructing purchasable cards
      // from Database releases (which contain no verified Shopify sale data).
      const fetchLiveSearch = async (userQuery, signal) => {
        const query = String(userQuery || '').trim();
        if (!query) return null;

        const root = window.Shopify?.routes?.root || '/';
        const url = new URL(`${root.replace(/\/$/, '')}/search/suggest`, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('section_id', liveSearchSectionId);
        const cached = storeResults.get(url.href);
        if (cached && Date.now() - cached.time < 30000) return cached.node.cloneNode(true);

        const response = await fetch(url.toString(), {
          signal,
          headers: {Accept: 'text/html'}
        });
        if (!response.ok) throw new Error(`Shop search returned ${response.status}`);

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const node = parsed.querySelector('[data-nubs-predictive-results]');
        if (node) {
          storeResults.delete(url.href);
          storeResults.set(url.href, {time: Date.now(), node});
          while (storeResults.size > 24) storeResults.delete(storeResults.keys().next().value);
        }
        return node;
      };

      // Both header modes use the same ranked public release catalog. Shop uses
      // catalog IDs to improve the order of Shopify's *verified* product cards.
      // If the catalog is temporarily unavailable, native Shopify results still work.
      const releaseResults = new Map();
      // Never reuse personalized ranking across sign-in / visibility changes.
      document.addEventListener('nubs:session-cleared', () => releaseResults.clear());
      const fetchRankedReleases = async (query, signal) => {
        const q = String(query || '').trim();
        if (q.length < 2) return [];
        const visibilityToken = window.NubsCatalogClient?.token?.() || '';
        const cacheKey = `${visibilityToken}::${q}`;
        const cached = releaseResults.get(cacheKey);
        if (cached && Date.now() - cached.time < 30000) return cached.items;
        const url = new URL(`${databaseBridge}/catalog/releases`);
        url.searchParams.set('q', q);
        url.searchParams.set('page', '1');
        url.searchParams.set('pageSize', '24');
        url.searchParams.set('sort', 'best-match');
        url.searchParams.set('facets', '0');
        if (visibilityToken) url.searchParams.set('visibilityToken', visibilityToken);
        // Bound bridge requests even if the shopper stops typing on a bad network.
        const bounded = new AbortController();
        const abort = () => bounded.abort();
        if (signal.aborted) return [];
        signal.addEventListener('abort', abort, {once:true});
        const timeout = window.setTimeout(abort, 2500);
        try {
          const reply = window.NubsCatalogClient
            ? await window.NubsCatalogClient.request(url, {signal:bounded.signal})
            : await fetch(url, {signal:bounded.signal, credentials:'omit', headers:{Accept:'application/json'}})
              .then(async response => ({ok:response.ok,payload:await response.json().catch(()=>null)}));
          if (signal.aborted || !reply.ok || !reply.payload?.ok) return [];
          const items = Array.isArray(reply.payload.items) ? reply.payload.items : [];
          releaseResults.delete(cacheKey);
          releaseResults.set(cacheKey, {time:Date.now(), items});
          while (releaseResults.size > 24) releaseResults.delete(releaseResults.keys().next().value);
          return items;
        } catch (_) {
          // Search suggestions must never fail because the catalog bridge is slow.
          return [];
        } finally {
          window.clearTimeout(timeout);
          signal.removeEventListener('abort', abort);
        }
      };

      const normalizeCatalogId = (value) => String(value || '').trim().toUpperCase();
      const normalizeUpc = (value) => String(value || '').replace(/[^0-9]/g, '');
      const rankShopCards = (host, releases) => {
        const list = host.querySelector('.site-search__product-list');
        if (!list || !releases?.length) return;
        const ranks = new Map(releases.map((release, index) => [normalizeCatalogId(release.catalogId), index]));
        const links = [...list.querySelectorAll('.site-search-result')];
        // Unknown/no-metafield products stay visible in their native Shopify order.
        const original = new Map(links.map((link, index) => [link, index]));
        links.sort((a, b) => {
          const ra = ranks.get(normalizeCatalogId(a.dataset.nubsShopCatalogId));
          const rb = ranks.get(normalizeCatalogId(b.dataset.nubsShopCatalogId));
          return (ra ?? Number.MAX_SAFE_INTEGER) - (rb ?? Number.MAX_SAFE_INTEGER)
            || original.get(a) - original.get(b);
        });
        links.forEach((link) => list.append(link));
      };

      // When Shopify doesn't recognize an alternate database title, try a
      // *bounded* UPC lookup for two of the ranked releases. Accept a result
      // ONLY when Shopify confirms the same catalog ID or exact variant barcode.
      // No full-catalog download and no speculative product URLs.
      const lookupCatalogShopCards = async (releases, signal) => {
        const found = [];
        const seen = new Set();
        let lookups = 0;
        for (const release of releases) {
          if (signal.aborted || lookups >= 2 || found.length >= 5) break;
          const upc = normalizeUpc(release.upc);
          if (upc.length < 8 || seen.has(upc)) continue;
          seen.add(upc);
          lookups += 1;
          try {
            const section = await fetchLiveSearch(upc, signal);
            if (!section || signal.aborted) break;
            const matches = [...section.querySelectorAll('.site-search-result')];
            const match = matches.find((link) =>
              normalizeCatalogId(link.dataset.nubsShopCatalogId) === normalizeCatalogId(release.catalogId)
              || String(link.dataset.nubsShopBarcodes || '').split('|').some((value) => normalizeUpc(value) === upc)
            );
            if (match && !found.some((item) => item.dataset.nubsShopProductId === match.dataset.nubsShopProductId)) {
              found.push(match.cloneNode(true));
            }
          } catch (_) { /* Shopify may throttle predictive requests: fail closed. */ }
        }
        return found;
      };

      const showEmptyShopResults = (query) => {
        results.innerHTML = `<div class="site-search__heading">Shop</div>
          <div class="site-search__empty">No matching shop titles.</div>
          <a class="site-search__view-all" href="${escapeHtml(searchUrl)}?q=${encodeURIComponent(query)}&amp;type=product">Search shop for “${escapeHtml(query)}”</a>`;
        openResults();
      };

      const fetchResults = async (userQuery) => {
        requestController?.abort();
        requestController = new AbortController();
        const {signal} = requestController;
        results.setAttribute('aria-busy', 'true');
        const isCurrent = () => !signal.aborted && userQuery === currentInput && mode?.value !== 'database';
        // Start the shared Database ranking request and Shopify discovery together.
        // Do not hold back native Shopify results waiting for the catalog service.
        const rankedPromise = fetchRankedReleases(userQuery, signal);
        try {
          const section = await fetchLiveSearch(userQuery, signal);
          if (!isCurrent()) return;
          if (section?.querySelector('.site-search-result')) {
            results.innerHTML = section.innerHTML;
            window.NubsCatalogImages?.observe?.(results);
            window.NubsCatalogOrder?.normalizeGrid(
              results.querySelector('.site-search__product-list'), '.site-search-result'
            );
            activeIndex = -1;
            openResults();
            // Reorder only the Shopify-confirmed cards by the shared Database
            // ranking. Never surface a database-only title as a product.
            rankedPromise.then((releases) => {
              if (!isCurrent() || activeIndex >= 0 || results.matches(':hover') ||
                  results.contains(document.activeElement)) return;
              rankShopCards(results, releases);
            });
            return;
          }
          // Shopify might not know an alternate catalog title. Look up a
          // bounded number of ranked releases by exact UPC before fuzzy fallback.
          const releases = await rankedPromise;
          if (!isCurrent()) return;
          const cards = await lookupCatalogShopCards(releases, signal);
          if (!isCurrent()) return;
          if (cards.length) {
            results.innerHTML = `<div class="site-search__heading">Matching shop titles</div>
              <div class="site-search__product-list"></div>
              <a class="site-search__view-all" href="${escapeHtml(searchUrl)}?q=${encodeURIComponent(userQuery)}&amp;type=product">Search shop for “${escapeHtml(userQuery)}”</a>`;
            const host = results.querySelector('.site-search__product-list');
            cards.forEach((card) => host.append(card));
            activeIndex = -1;
            window.NubsCatalogImages?.observe?.(results);
            openResults();
            return;
          }
          const usedFuzzy = await renderFuzzyLiveResults(userQuery, signal);
          if (!isCurrent()) return;
          activeIndex = -1;
          if (usedFuzzy) openResults();
          else showEmptyShopResults(userQuery);
        } catch (error) {
          if (signal.aborted || error?.name === 'AbortError') return;
          console.error('Nub’s Media shop suggestions error:', error);
          if (!isCurrent()) return;
          try {
            const usedFuzzy = await renderFuzzyLiveResults(userQuery, signal);
            if (!isCurrent()) return;
            if (usedFuzzy) {
              activeIndex = -1;
              openResults();
            } else showEmptyShopResults(userQuery);
          } catch (fallbackError) {
            if (isCurrent()) showEmptyShopResults(userQuery);
          }
        } finally {
          if (isCurrent()) results.setAttribute('aria-busy', 'false');
        }
      };

      const clearSearchField = () => {
        input.value = '';
        currentInput = '';
        activeIndex = -1;
      };

      const submitSearch = () => {
        const userQuery = input.value.trim();

        if (!userQuery) {
          return;
        }

        closeResults();
        clearSearchField();

        if (mode?.value === 'database') {
          const destination = new URL('/pages/my-collection', window.location.origin);
          destination.searchParams.set('q', userQuery);
          if (window.NubsSoftNavigation?.isEligible(destination)) window.NubsSoftNavigation.navigate(destination);
          else window.location.href = destination.toString();
          return;
        }

        const destination = new URL(searchUrl, window.location.origin);
        destination.searchParams.set('q', userQuery);
        destination.searchParams.set('type', 'product');
        if (window.NubsSoftNavigation?.isEligible(destination)) window.NubsSoftNavigation.navigate(destination);
        else window.location.href = destination.toString();
      };

      const queueSearch = () => {
        const userQuery = input.value.trim();
        currentInput = userQuery;
        clearTimeout(debounceTimer);
        // A new query drops only the not-yet-started speculative queue. Any
        // cover already fetched or in flight remains useful in browser cache.
        window.NubsCatalogImages?.cancelSpeculation?.();
        if (mode?.value === 'database') {
          if (requestController) requestController.abort();
          if (userQuery.length < 2) {
            closeResults();
            return;
          }
          debounceTimer = window.setTimeout(() => {
            renderDatabaseResults(userQuery).catch((error) => {
              /*
               * Typing a new character intentionally cancels the previous
               * database lookup. Firefox can surface that cancellation as
               * AbortError, a DOMException, or occasionally a NetworkError.
               * Those are expected control-flow events, not search failures.
               */
              const aborted = requestController?.signal?.aborted
                || error?.name === 'AbortError'
                || (error instanceof DOMException && /abort/i.test(error.message || ''));
              if (aborted) return;

              console.error('Nub’s Media database search error:', error);
              if (userQuery === currentInput) closeResults();
            });
          }, window.NubsCatalogClient?.ready ? 25 : 100);
          return;
        }

        if (userQuery.length < 2) {
          if (requestController) {
            requestController.abort();
          }

          closeResults();
          return;
        }

        debounceTimer = window.setTimeout(() => {
          fetchResults(userQuery);
        }, 100);
      };


      mode?.addEventListener('change', () => {
        window.NubsCatalogImages?.cancelSpeculation?.();
        closeResults();
        input.placeholder = mode.value === 'database'
          ? 'Search database titles, publishers, UPCs...'
          : 'Search titles, studios, publishers, UPCs...';
        input.setAttribute('aria-label', mode.value === 'database' ? 'Search database' : "Search Nub's Media shop");
        input.focus();
        if (input.value.trim().length >= 2) queueSearch();
      });

      input.addEventListener('input', queueSearch);

      input.addEventListener('focus', () => {
        const userQuery = input.value.trim();

        if (userQuery.length >= 2 && results.innerHTML.trim() !== '') {
          openResults();
        } else if (userQuery.length >= 2) {
          queueSearch();
        }
      });

      input.addEventListener('keydown', (event) => {
        const links = getResultLinks();

        if (event.key === 'Escape') {
          closeResults();
          return;
        }

        if (event.key === 'Enter' && !event.isComposing && event.keyCode !== 229) {
          if (links.length && !results.hidden && activeIndex >= 0) {
            event.preventDefault();
            const activeLink = links[activeIndex];
            clearSearchField();
            activeLink?.click();
          } else {
            // Do not rely on the browser's implicit form-submit behaviour here.
            // Explicit submission keeps Enter reliable while the rest of the page
            // contains summaries, filter pills, drawers, and other controls.
            event.preventDefault();
            submitSearch();
          }
          return;
        }

        if (!links.length || results.hidden) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();

          setActiveResult(
            activeIndex < links.length - 1
              ? activeIndex + 1
              : 0
          );

          return;
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();

          setActiveResult(
            activeIndex > 0
              ? activeIndex - 1
              : links.length - 1
          );

          return;
        }

      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitSearch();
      });

      // Choosing a live result is also a completed use of the header search.
      // The header survives soft navigation, so clear its query before navigating
      // instead of making the shopper manually erase the previous search.
      results.addEventListener('click', (event) => {
        if (event.target.closest?.('a[href]')) clearSearchField();
      });

      document.addEventListener('nubs:beforepagechange', () => { clearTimeout(debounceTimer); requestController?.abort(); closeResults(); });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) {
          closeResults();
        }
      });

    })();

